import React, { useState } from 'react';
import './EmployeeLeaveHome.css';

const EmployeeLeaveHome = ({ onApplyLeave, onViewHistory }) => {
  const [activeTab, setActiveTab] = useState('balance'); // 'balance' or 'holidays'

  // Sample leave data
  const leaveTypes = [
    {
      id: 1,
      name: 'Casual Leave',
      availed: 5,
      available: 2,
      color: '#5B7FBF'
    },
    {
      id: 2,
      name: 'Sick Leave',
      availed: 5,
      available: 2,
      color: '#3B5998'
    },
    {
      id: 3,
      name: 'Loss Of Pay',
      availed: 5,
      available: 2,
      color: '#4A5568'
    }
  ];

  // Sample holidays data
  const holidays = [
    { id: 1, name: 'New Year', date: '01 Jan 2025', day: 'Wednesday' },
    { id: 2, name: 'Republic Day', date: '26 Jan 2025', day: 'Sunday' },
    { id: 3, name: 'Holi', date: '14 Mar 2025', day: 'Friday' },
    { id: 4, name: 'Good Friday', date: '18 Apr 2025', day: 'Friday' },
    { id: 5, name: 'Independence Day', date: '15 Aug 2025', day: 'Friday' },
    { id: 6, name: 'Diwali', date: '20 Oct 2025', day: 'Monday' },
    { id: 7, name: 'Christmas', date: '25 Dec 2025', day: 'Thursday' },
  ];

  const handleApply = (leaveType) => {
    if (onApplyLeave) {
      onApplyLeave(leaveType);
    }
  };

  return (
    <div className="leave-home">
      {/* Header */}
      <div className="leave-header">
        <h1>Leave Summary</h1>
      </div>

      {/* Content */}
      <div className="leave-content">
        {/* Tabs */}
        <div className="leave-tabs">
          <button
            className={`leave-tab ${activeTab === 'balance' ? 'active' : ''}`}
            onClick={() => setActiveTab('balance')}
          >
            Leave Balance
          </button>
          <button
            className={`leave-tab ${activeTab === 'holidays' ? 'active' : ''}`}
            onClick={() => setActiveTab('holidays')}
          >
            Holidays
          </button>
        </div>

        {/* Tab Content */}
        {activeTab === 'balance' ? (
          <div className="leave-cards">
            {leaveTypes.map((leave) => (
              <div className="leave-card" key={leave.id}>
                <div 
                  className="leave-card-accent" 
                  style={{ backgroundColor: leave.color }}
                ></div>
                <div className="leave-card-content">
                  <div className="leave-card-info">
                    <h3 className="leave-type-name">{leave.name}</h3>
                    <div className="leave-stats">
                      <div className="leave-stat">
                        <span className="stat-label">Availed</span>
                        <span className="stat-value availed">
                          {String(leave.availed).padStart(2, '0')}
                        </span>
                      </div>
                      <div className="leave-stat">
                        <span className="stat-label">Available</span>
                        <span className="stat-value available">
                          {String(leave.available).padStart(2, '0')}
                        </span>
                      </div>
                    </div>
                  </div>
                  <button 
                    className="apply-btn"
                    onClick={() => handleApply(leave)}
                  >
                    Apply
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="holidays-list">
            {holidays.map((holiday) => (
              <div className="holiday-card" key={holiday.id}>
                <div className="holiday-card-accent"></div>
                <div className="holiday-card-content">
                  <div className="holiday-info">
                    <h3 className="holiday-name">{holiday.name}</h3>
                    <span className="holiday-day">{holiday.day}</span>
                  </div>
                  <div className="holiday-date">{holiday.date}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* History Button */}
        <div className="leave-footer">
          <button className="history-btn" onClick={onViewHistory}>
            History
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeLeaveHome;

